import {Component, Input, OnInit, inject, DestroyRef} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {SidenavService} from 'src/app/services/util/sidenav.service';
import {Notification} from 'src/app/models/notification/notification';
import {NotificationsService} from 'src/app/services/api/notifications.service';

@Component({
    selector: 'app-notifications-list',
    templateUrl: './notifications-list.component.html',
    styleUrls: ['./notifications-list.component.scss'],
    standalone: false
})
export class NotificationsListComponent  implements OnInit {
  @Input() title: string;
  sent: boolean;
  notifications: Notification[] = [];
private destroyRef = inject(DestroyRef);
  constructor(public sidenavService: SidenavService, private formBuilder: UntypedFormBuilder, private notificationsService: NotificationsService) {
    
  }

  ngOnInit(): void {
    this.notifications = this.notificationsService.getNotifications();
  }

  markAsRead(notification: Notification): void {
    if (!notification.state.read) {
      this.notificationsService.markAsRead(notification.id)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe();
    }
  }

}
